import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    padding: 20,
    backgroundColor: "#fff",
    flex: 1,
  },
  card: {
    marginBottom: 20,
    borderRadius: 8,
    elevation: 4,
  },
  title: {
    color: "#077A97",
    fontSize: 18,
    fontWeight: "bold",
  },
  section: {
    marginVertical: 10,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#333",
  },
  progressBar: {
    height: 10,
    marginVertical: 10,
  },
  bulletPoint: {
    marginLeft: 10,
    fontSize: 14,
    lineHeight: 22,
  },
  labelBold: {
    fontWeight: "bold",
    color: "#333",
    fontSize: 14,
    lineHeight: 22,
  },
  valueText: {
    color: "#077A97",
    fontSize: 14,
    lineHeight: 22,
  },
  horizontalContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  textContainer: {
    flexDirection: "column",
    marginRight: 80,
  },
  imageIcon: {
    width: 60,
    height: 40,
  },
});

export default styles;
